// app.routes.ts
import { Routes } from "@angular/router";
import { OktaCallbackComponent } from "@okta/okta-angular";
import { DataCacheGuard, assetExistsGuard, gateExistsGuard, siteExistsGuard, tagExistsGuard, oktaCanActivate, TitleResolver, gateSystemsExistsGuard, gseAssetsExistsGuard, cameraExistsGuard, orgContextGuard } from "shared-lib";
import { legacyOrgRewriteGuard } from "./guards/legacy-org-rewrite.guard";

// Small helpers to keep things readable
const fromShared = () => import("shared-lib");
// const import = (p: string) => import(p);



export const routes: Routes = [
  // Keep this tiny callback eager (or lazy it if you prefer—see comment below)
  {
    path: "login/callback",
    component: OktaCallbackComponent,
    // If you want this lazy as well:
    // loadComponent: () => import("@okta/okta-angular").then(m => m.OktaCallbackComponent),
  },
  // Moved under /o/:orgId (kept via legacy rewrite)
  // App init (lazy, so initial bundle stays lean) Possibly TODO make the loading screen here appear somewhere else
  // {
  //   path: "",
  //   loadComponent: () => fromShared().then(m => m.AppInitComponent),
  // },

  // Login (already lazy before; preserved)
  {
    path: "login",
    loadComponent: () => import("./components/login/login.page").then(m => m.LoginPage),
    title: 'Login',
  },
  {
    path: "logout",
    loadComponent: () => import("./components/logout/logout.page").then(m => m.LogoutPage),
    title: 'Logout',
  },
  {
    path: "authenticating",
    loadComponent: () => import("./components/authenticating/authenticating.page").then(m => m.AuthenticatingPage),
    title: 'Authenticating',
  },
  // Legal (unguarded)
  {
    path: "terms",
    loadComponent: () => import("./components/terms/terms-list.page").then(m => m.TermsListPage),
    title: "Terms",
  },
  {
    path: "terms/:id",
    loadComponent: () => import("./components/terms/terms-view.page").then(m => m.TermsViewPage),
    title: "Terms",
  },
  {
    path: "",
    loadComponent: () => import("./components/applayout/applayout.component").then(m => m.ApplayoutComponent),
    canActivate: [oktaCanActivate, DataCacheGuard],
    children: [
      {
        path: "",
        pathMatch: "full",
        loadComponent: () =>
          import("./components/org-default-redirect/org-default-redirect.component").then(
            m => m.OrgDefaultRedirectComponent
          ),
      },
      {
        path: "push-notifications/asset-summary/:assetId",
        loadComponent: () => fromShared().then(m => m.PushNotificationsComponent),
      },
      {
        path: "push-notifications/asset-summary/:assetId/:target",
        loadComponent: () => fromShared().then(m => m.PushNotificationsComponent),
      },
      {
        path: "o/:orgId",
        canActivate: [orgContextGuard],
        children: [
          { path: "", redirectTo: "organization-summary", pathMatch: "full" },
          { path: "home", redirectTo: "organization-summary", pathMatch: "full" },
          { path: "home/**", redirectTo: "organization-summary", pathMatch: "full" },

          {
            path: "signalRTest",
            loadComponent: () => fromShared().then(m => m.TagListComponent),
          },
          {
            path: "insight-audit",
            loadComponent: () => fromShared().then(m => m.InsightAuditorComponent),
            title: "Insight Auditor",
          },
          {
            path: "insight-auditor",
            loadComponent: () => fromShared().then(m => m.InsightAuditorComponent),
            title: "Insight Auditor",
          },
          {
            path: "admin/insight-audit",
            loadComponent: () => fromShared().then(m => m.InsightAuditorComponent),
            title: "Insight Auditor",
          },
          {
            path: "user-engagement-report",
            loadComponent: () => fromShared().then(m => m.UserEngagementReportComponent),
            title: "User Engagement Report",
          },
          {
            path: "admin/user-engagement-report",
            loadComponent: () => fromShared().then(m => m.UserEngagementReportComponent),
            title: "User Engagement Report",
          },
          {
            path: "admin/insight-auditor",
            loadComponent: () => fromShared().then(m => m.InsightAuditorComponent),
            title: "Insight Auditor",
          },

                {
        path: "pm-verification/start",
        loadComponent: () => fromShared().then(m => m.PMStartInspectionComponent),
        title: "Start PM Inspection",
      },
      {
        path: "pm-verification/execution/:pmExecutionId",
        loadComponent: () => fromShared().then(m => m.PMChecklistExecutionComponent),
        title: "PM Checklist Execution",
      },
      {
        path: "pm-verification/execution/:pmExecutionId/summary",
        loadComponent: () => fromShared().then(m => m.PMCompletionSummaryComponent),
        title: "PM Completion Summary",
      },
      {
        path: "pm-verification/execution/:pmExecutionId/review",
        loadComponent: () => fromShared().then(m => m.PMReviewComponent),
        title: "PM Review",
      },
      {
        path: "pm-verification/templates/create",
        loadComponent: () => fromShared().then(m => m.PMTemplateCreateComponent),
        title: "Create PM Template",
      },
      {
        path: "pm-verification/templates/:pmTemplateId/tasks",
        loadComponent: () => fromShared().then(m => m.PMTemplateTasksComponent),
        title: "PM Template Tasks",
      },
      {
        path: "pm-verification/templates/:pmTemplateId",
        loadComponent: () => fromShared().then(m => m.PMTemplateDetailComponent),
        title: "PM Template Detail",
      },
      {
        path: "pm-verification/templates",
        loadComponent: () => fromShared().then(m => m.PMTemplateManagementComponent),
        title: "PM Template Management",
      },

        {
          path: "pm-verification",
          loadComponent: () => fromShared().then(m => m.PMAssetOverviewComponent),
          title: "PM Inspections Overview",
        },
      // {
      //   path: "",
      //   pathMatch: 'full',
      //   loadComponent: () => import("./components/home-screen/home-screen.page").then(m => m.HomeScreenPage),
      //   title: 'Home',
      // },
      // {
      //   path: "overview",
      //   loadComponent: () => import("./components/overview/overview.page").then(m => m.OverviewPage),
      //   title: 'Overview',
      // },

      // SEARCH (list & map lazy)
      {
        path: "search",
        loadComponent: () => fromShared().then(m => m.SearchResultsPageComponent),
        children: [
          { path: "", redirectTo: "list", pathMatch: "full" },
          { path: "list", loadComponent: () => fromShared().then(m => m.SearchResultsListComponent) },
          { path: "map", loadComponent: () => fromShared().then(m => m.SearchResultsMapPageComponent) },
        ]
      },

      {
        path: "settings",
        children: [
          {
            path: "",
            loadComponent: () => import("./components/settings/settings.page").then(m => m.SettingsPage),
            title: 'Settings',
          },
          {
            path: "alert-settings",
            loadComponent: () => fromShared().then(m => m.AlertSettingsComponent),
            title: 'Alert Settings',
          },
        ]
      },

      {
        path: "admin-tools",
        loadComponent: () => import("./components/admin-tools/admin-tools.page").then(m => m.AdminToolsPage),
        title: 'Admin Tools',
      },
      {
        path: "admin",
        redirectTo: "admin-tools",
        pathMatch: "full",
      },

      {
        path: "reports/daily-aircraft-docked",
        loadComponent: () => import("./components/reports/daily-aircraft-docked-summary.page").then(m => m.DailyAircraftDockedSummaryPage),
        title: 'Daily Aircraft Docked',
      },

      {
        path: "reports/daily-aircraft-docked-print",
        loadComponent: () =>
          import("./components/reports/daily-aircraft-docked-print-report.page").then(
            m => m.DailyAircraftDockedPrintReportPage
          ),
        title: 'Daily Aircraft Docked Report',
      },

      {
        path: "reports/daily-aircraft-docked-settings",
        loadComponent: () =>
          import("./components/reports/daily-aircraft-docked-settings.page").then(
            m => m.DailyAircraftDockedSettingsPage
          ),
        title: 'Daily Aircraft Docked Settings',
      },

      {
        path: "reports/alarms-summary",
        loadComponent: () => import("./components/reports/alarms-summary.page").then(m => m.AlarmsSummaryPage),
        title: 'Alarms',
      },

      {
        path: "reports/alarms-settings",
        loadComponent: () => import("./components/reports/alarms-settings.page").then(m => m.AlarmsSettingsPage),
        title: 'Alarms Settings',
      },

      {
        path: "reports/alarms-print",
        loadComponent: () => import("./components/reports/alarms-print-report.page").then(m => m.AlarmsPrintReportPage),
        title: 'Alarms Report',
      },

      {
        path: "reports/gse-asset-alarms-summary",
        loadComponent: () => import("./components/reports/gse-asset-alarms-summary.page").then(m => m.GseAssetAlarmsSummaryPage),
        title: 'Asset Alarms',
      },

      {
        path: "reports/gse-asset-alarms-settings",
        loadComponent: () => import("./components/reports/gse-asset-alarms-settings.page").then(m => m.GseAssetAlarmsSettingsPage),
        title: 'Asset Alarms Settings',
      },

      {
        path: "reports/gse-asset-alarms-print",
        loadComponent: () => import("./components/reports/gse-asset-alarms-print-report.page").then(m => m.GseAssetAlarmsPrintReportPage),
        title: 'Asset Alarms Report',
      },

      {
        path: "reports/equipment-levels",
        loadComponent: () => import("./components/reports/equipment-levels-summary.page").then(m => m.EquipmentLevelsSummaryPage),
        title: 'Equipment Levels',
      },

      {
        path: "reports/ahu-overview",
        loadComponent: () => import("./components/reports/ahu-overview-report.page").then(m => m.AhuOverviewReportPage),
        title: 'AHU Monitoring',
      },

      {
        path: "reports/deicing-truck-levels",
        loadComponent: () => import("./components/reports/deicing-truck-levels-summary.page").then(m => m.DeicingTruckLevelsSummaryPage),
        title: 'Deicing Truck Levels',
      },

      {
        path: "reports/equipment-usage",
        loadComponent: () => import("./components/reports/equipment-usage-report.page").then(m => m.EquipmentUsageReportPage),
        title: 'Equipment Usage Report',
      },

      {
        path: "reports/gate-system-usage",
        loadComponent: () => import("./components/reports/gate-system-usage-report.page").then(m => m.GateSystemUsageReportPage),
        title: 'Equipment Usage Report',
      },

      {
        path: "reports/jetdock-value",
        loadComponent: () => import("./components/reports/jetdock-value-report.page").then(m => m.JetDockValueReportPage),
        title: 'JetDock Value',
      },

      {
        path: "reports/gpu-power-consumption",
        loadComponent: () =>
          import("./components/reports/gpu-power-consumption-report.page").then(
            m => m.GpuPowerConsumptionReportPage
          ),
        title: 'GPU Power Consumption Report',
      },

      {
        path: "reports/diagnostic-print",
        loadComponent: () => import("./components/reports/diagnostic-print-report.page").then(m => m.DiagnosticPrintReportPage),
        title: 'Diagnostic Report',
      },

      {
        path: "reports",
        redirectTo: "organization-summary/more",
        pathMatch: "full",
      },

      {
        path: "tag-modal",
        canActivate: [tagExistsGuard],
        loadComponent: () => fromShared().then(m => m.TagGraphModalHouseComponent),
      },

      {
        path: "tag-graph/config",
        loadComponent: () => fromShared().then(m => m.TagGraphConfigComponent),
      },

      {
        path: "styleguide/palette",
        loadComponent: () => fromShared().then(m => m.PaletteComponent),
        title: 'Palette',
      },

      {
        path: "dynamic-insights-grid",
        loadComponent: () => fromShared().then(m => m.DynamicInsightsGridComponent),
        title: TitleResolver,
      },


      // {
      //   path: "home-screen",
      //   loadComponent: () => import("./components/home-screen/home-screen.page").then(m => m.HomeScreenPage),
      //   title: 'Home',
      // },

      {
        path: "organization-summary",
        // canActivate: [DataCacheGuard],
        loadComponent: () => fromShared().then(m => m.OrganizationSummaryPageComponent),
        children: [
          { path: "", redirectTo: "overview", pathMatch: "full" },
          { path: "overview", loadComponent: () => fromShared().then(m => m.OrganizationOverviewPageComponent), title: TitleResolver },
          { path: "alarms", loadComponent: () => fromShared().then(m => m.OrganizationAlarmsComponent), title: TitleResolver },
          { path: "gates-view", loadComponent: () => fromShared().then(m => m.GatesViewComponent), title: TitleResolver },
          { path: "gate-overview", loadComponent: () => fromShared().then(m => m.GateOverviewComponent), title: TitleResolver },
          {path: "tags", loadComponent: () => fromShared().then(m => m.OrganizationTagsComponent), title: TitleResolver},
          {path: "more", loadComponent: () => fromShared().then(m => m.OrganizationSummaryMoreComponent), title: TitleResolver, },
          {path: "camera-monitoring", loadComponent: () => fromShared().then(m => m.OrganizationCameraMonitoringComponent), title: TitleResolver},
          {path: "fleet-overview", canActivate: [gseAssetsExistsGuard], loadComponent: () => fromShared().then(m => m.FleetOverviewComponent), title: TitleResolver, runGuardsAndResolvers: 'pathParamsChange'},
          {path: "map", loadComponent: () => fromShared().then(m => m.AssetMapComponent), title: TitleResolver, },
          { path: 'assets-view', pathMatch: 'full', loadComponent: () => fromShared().then(m => m.AssetsViewComponent), title: TitleResolver,  },


          {
            path: "videos",
            loadComponent: () => fromShared().then(m => m.OrganizationVideosComponent),
            title: TitleResolver,
            children: [
	              {
	                path: "camera/:id",
	                canActivate: [cameraExistsGuard],
	                loadComponent: () => fromShared().then(m => m.CameraViewComponent),
	                title: TitleResolver,
	                children: [
	                  { path: "", redirectTo: "live", pathMatch: "full" },
	                  { path: "live", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoLiveComponent) },
	                  { path: "historical", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoHistoricalComponent) }
	                ]
	              },
	              {
	                // Multi-camera view by explicit camera ids:
	                //   .../videos/multi/live?ids=139,208,114,280
	                // Also supports:
	                //   .../videos/multi/live&ids=139,208,114,280
	                path: "multi",
	                loadComponent: () => fromShared().then(m => m.CameraViewComponent),
	                title: TitleResolver,
	                children: [
	                  { path: "", redirectTo: "live", pathMatch: "full" },
	                  { path: "live", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoLiveComponent) },
	                  { path: "live&ids=:ids", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoLiveComponent) },
	                  { path: "historical-configuration", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoHistoricalMultiConfigurationComponent) },
	                  { path: "historical-configuration&ids=:ids", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoHistoricalMultiConfigurationComponent) },
	                  { path: "historical", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoHistoricalMultiComponent) },
	                  { path: "historical&ids=:ids", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoHistoricalMultiComponent) },
	                ]
	              },
	              {
	                path: "system/:id",
	                loadComponent: () => fromShared().then(m => m.CameraViewComponent),
	                title: TitleResolver,
	                children: [
                  { path: "", redirectTo: "live", pathMatch: "full" },
                  { path: "live", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoLiveComponent) },
                  { path: "live/camera/:cameraId", canActivate: [cameraExistsGuard], title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoLiveComponent) },
                  { path: "historical-configuration", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoHistoricalMultiConfigurationComponent) },
                  { path: "historical", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoHistoricalMultiComponent) },
                ]
              },
            ],
          },
          // Organization Tactical Reports
          {
            path: "tactical-report",
            loadComponent: () => fromShared().then(m => m.TacticalReportingComponent),
            children: [

              // GS Available Assets
              {
                path: "gs-available-assets",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSAvailableAssetsComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSAvailableAssetsSummaryComponent) },
                  { path: "duration", loadComponent: () => fromShared().then(m => m.TacticalGSAvailableAssetsDurationComponent) },
                  { path: "detail", loadComponent: () => fromShared().then(m => m.TacticalGSAvailableAssetsAggregateComponent) },
                ]
              },

              // GS Alarm Status
              {
                path: "gs-alarm-status",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSAlarmStatusComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSAlarmStatusSummaryComponent) },
                  { path: "duration", loadComponent: () => fromShared().then(m => m.TacticalGSAlarmStatusDurationComponent) },
                  { path: "detail", loadComponent: () => fromShared().then(m => m.TacticalGSAlarmStatusDetailComponent) },
                  { path: "category", loadComponent: () => fromShared().then(m => m.TacticalGSAlarmStatusDetailComponent) },
                ]
              },

              // GSE Fleet Assets In Use
              {
                path: "gse-assets-in-use",
                canActivate: [gseAssetsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSEAssetsInUseComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSEAssetsInUseSummaryComponent) },
                  { path: "count", loadComponent: () => fromShared().then(m => m.TacticalGSEAssetsInUseCountComponent) },
                  { path: "duration", loadComponent: () => fromShared().then(m => m.TacticalGSEAssetsInUseDurationComponent) },
                  { path: "active-time", loadComponent: () => fromShared().then(m => m.TacticalGSEAssetsInUseActiveTimeComponent) },
                ]
              },

              // GS Assets In Use
              {
                path: "gs-assets-in-use",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSAssetsInUseComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSAssetsInUseSummaryComponent) },
                  { path: "count", loadComponent: () => fromShared().then(m => m.TacticalGSAssetsInUseCountComponent) },
                  { path: "duration", loadComponent: () => fromShared().then(m => m.TacticalGSAssetsInUseDurationComponent) },
                  { path: "total-used", loadComponent: () => fromShared().then(m => m.TacticalGSAssetsInUseTotalUsedComponent) },
                  { path: "type-used", loadComponent: () => fromShared().then(m => m.TacticalGSAssetsInUseTypeUsedComponent) },
                  { path: "type-not-used", loadComponent: () => fromShared().then(m => m.TacticalGSAssetsInUseTypeNotUsedComponent) },
                  { path: "detail", loadComponent: () => fromShared().then(m => m.TacticalGSAssetsInUseDetailComponent) },
                ]
              },

              // Equipment Cycle/Runtime
              {
                path: "equipment",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalEquipmentCycleCountComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalEquipmentCycleCountSummaryComponent) },
                  { path: "cycle-count-report", loadComponent: () => fromShared().then(m => m.TacticalEquipmentCycleCountReportComponent) },
                  { path: "type-cycle-count-report", loadComponent: () => fromShared().then(m => m.TacticalEquipmentTypeCycleCountReportComponent) },
                  { path: "total-cycle-count-report", loadComponent: () => fromShared().then(m => m.TacticalEquipmentTotalCycleCountReportComponent) },
                  { path: "runtime-report", loadComponent: () => fromShared().then(m => m.TacticalEquipmentRuntimeReportComponent) },
                  { path: "type-runtime-report", loadComponent: () => fromShared().then(m => m.TacticalEquipmentTypeRuntimeReportComponent) },
                  { path: "total-runtime-report", loadComponent: () => fromShared().then(m => m.TacticalEquipmentTotalRuntimeReportComponent) },
                ]
              },

              // Levels
              {
                path: "tactical-levels",
                canActivate: [gseAssetsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalLevelsComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalAssetCurrentLevelsReportComponent) },
                  { path: "current-levels-report", loadComponent: () => fromShared().then(m => m.TacticalCurrentLevelsReportComponent) },
                  { path: "tactical-fuel-levels-report", loadComponent: () => fromShared().then(m => m.TacticalFuelLevelsReportComponent) },
                  { path: "tactical-def-tank-levels-report", loadComponent: () => fromShared().then(m => m.TacticalDefTankLevelsReportComponent) },
                  { path: "tactical-antiice-levels-report", loadComponent: () => fromShared().then(m => m.TacticalAntiiceLevelsReportComponent) },
                  { path: "tactical-battery-levels-report", loadComponent: () => fromShared().then(m => m.TacticalBatteryLevelsReportComponent) },
                  { path: "tactical-deicer-levels-report", loadComponent: () => fromShared().then(m => m.TacticalDeicerLevelsReportComponent) },
                ]
              },

              // PCA Performance
              {
                path: "pca-not-meeting-performance",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.PcaNotMeetingPerformanceComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "current", loadComponent: () => fromShared().then(m => m.PcaNotMeetingPerformanceCurrentComponent) },
                  { path: "chart", loadComponent: () => fromShared().then(m => m.PcaNotMeetingPerformanceChartComponent) },
                  { path: "asset-report", loadComponent: () => fromShared().then(m => m.PcaNotMeetingPerformanceAssetReportComponent) },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.PcaNotMeetingPerformanceSummaryComponent) },
                ]
              },

              // GPU Out Of Compliance
              {
                path: "gpu-out-of-compliance",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                children: [
                  { path: "", loadComponent: () => fromShared().then(m => m.GpuOutOfComplianceSummaryComponent) },
                  { path: "summary", redirectTo: "", pathMatch: "full" },
                ]
              },

              // PBB Out Of Compliance
              {
                path: "pbb-out-of-compliance",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                children: [
                  { path: "", loadComponent: () => fromShared().then(m => m.PbbOutOfComplianceSummaryComponent) },
                  { path: "summary", redirectTo: "", pathMatch: "full" },
                ]
              },

              // PBB Docking
              {
                path: "pbb-docking",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.PbbDockingComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.PbbDockingSummaryComponent) },
                  { path: "current", loadComponent: () => fromShared().then(m => m.PbbDockingCurrentComponent) },
                  { path: "duration-report", loadComponent: () => fromShared().then(m => m.PbbDockingDurationReportComponent) },
                  { path: "count-report", loadComponent: () => fromShared().then(m => m.PbbDockingCountReportComponent) },
                  { path: "total-count-report", loadComponent: () => fromShared().then(m => m.PbbDockingTotalCountReportComponent) },
                  { path: "total-duration-report", loadComponent: () => fromShared().then(m => m.PbbDockingTotalDurationReportComponent) },
                ]
              },

              // GS Alarms (org)
              {
                path: "tactical-gstop-five-alarms",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSTopFiveAlarmsComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "topFaults", loadComponent: () => fromShared().then(m => m.TacticalGSTopFiveAlarmsChartComponent) },
                  { path: "categoryTopFaults", loadComponent: () => fromShared().then(m => m.TacticalGSTopFiveAlarmsChartComponent) },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSTopFiveAlarmsSummaryComponent) },
                  { path: "topFaultsByAsset", loadComponent: () => fromShared().then(m => m.TacticalGSTopFiveAlarmsByAssetComponent) },
                  { path: "historical", loadComponent: () => fromShared().then(m => m.TacticalGSTopFiveAlarmsHistoricalComponent) },
                ]
              },

              // GSE Alarms (org)
              {
                path: "tactical-gsetop-five-alarms",
                canActivate: [gseAssetsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSETopFiveAlarmsComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "topFaults", loadComponent: () => fromShared().then(m => m.TacticalGSETopFiveAlarmsChartComponent) },
                  { path: "categoryTopFaults", loadComponent: () => fromShared().then(m => m.TacticalGSETopFiveAlarmsChartComponent) },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSETopFiveAlarmsSummaryComponent) },
                  { path: "topFaultsByAsset", loadComponent: () => fromShared().then(m => m.TacticalGSETopFiveAlarmsByAssetComponent) },
                  { path: "historical", loadComponent: () => fromShared().then(m => m.TacticalGSETopFiveAlarmsHistoricalComponent) },
                ]
              },

              // Out of service (GS/GSE)
              {
                path: "tactical-gs-out-of-service",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSOutOfServiceComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSOutOfServiceSummaryComponent) },
                  { path: "historical", loadComponent: () => fromShared().then(m => m.TacticalGSOutOfServiceChartComponent) },
                ]
              },
              {
                path: "tactical-gse-out-of-service",
                canActivate: [gseAssetsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSEOutOfServiceComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSEOutOfServiceSummaryComponent) },
                  { path: "historical", loadComponent: () => fromShared().then(m => m.TacticalGSEOutOfServiceChartComponent) },
                ]
              },

              // Fleet usage (GSE)
              {
                path: "tactical-gse-fleet-usage",
                canActivate: [gseAssetsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSEFleetUsageComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSEFleetUsageSummaryComponent) },
                  { path: "usage", loadComponent: () => fromShared().then(m => m.TacticalGSEFleetUsageChartComponent) },
                  { path: "driven", loadComponent: () => fromShared().then(m => m.TacticalGSEFleetUsageDrivenChartComponent) },
                  { path: "idle", loadComponent: () => fromShared().then(m => m.TacticalGSEFleetUsageIdleChartComponent) },
                  { path: "usageDetail", loadComponent: () => fromShared().then(m => m.TacticalGSEFleetUsageDetailChartComponent) },
                  { path: "drivenDetail", loadComponent: () => fromShared().then(m => m.TacticalGSEFleetUsageDrivenDetailChartComponent) },
                  { path: "idleDetail", loadComponent: () => fromShared().then(m => m.TacticalGSEFleetUsageIdleDetailChartComponent) },
                ]
              },

              // Available assets / not used / charging system
              {
                path: "tactical-gse-available-assets",
                canActivate: [gseAssetsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSEAvailableAssetsComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSEAvailableAssetsSummaryComponent) },
                  { path: "minutesOffPerDay", loadComponent: () => fromShared().then(m => m.TacticalGSEAvailableAssetsChartComponent) },
                ]
              },
              {
                path: "tactical-gs-equipment-not-used",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSEquipmentNotUsedComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSEquipmentNotUsedSummaryComponent) },
                  { path: "minutesnotUsedPerDay", loadComponent: () => fromShared().then(m => m.TacticalGSEquipmentNotUsedChartComponent) },
                  { path: "minutesUsedByType", loadComponent: () => fromShared().then(m => m.TacticalGSEquipmentUsedByTypeChartComponent) },
                  { path: "minutesNotUsedByType", loadComponent: () => fromShared().then(m => m.TacticalGSEquipmentNotUsedByTypeChartComponent) },
                  { path: "usedDetail", loadComponent: () => fromShared().then(m => m.TacticalGSEquipmentUsageDetailChartComponent) },
                ]
              },
              {
                path: "tactical-gs-comms-loss",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSCommsLossComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSCommsLossSummaryComponent) },
                  { path: "detail", loadComponent: () => fromShared().then(m => m.TacticalGSCommsLossDetailChartComponent) },
                  { path: "time", loadComponent: () => fromShared().then(m => m.TacticalGSCommsLossTimeChartComponent) },
                ]
              },
              {
                path: "tactical-intelligent-charging-system",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalIntelligentChargingSystemComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalIntelligentChargingSystemSummaryComponent) },
                  { path: "chargedDurationByDay", loadComponent: () => fromShared().then(m => m.TacticalIntelligentChargingSystemChargedByDayDurationChartComponent) },
                  { path: "chargedDuration", loadComponent: () => fromShared().then(m => m.TacticalIntelligentChargingSystemChargedDurationChartComponent) },
                  { path: "counts", loadComponent: () => fromShared().then(m => m.TacticalIntelligentChargingSystemChargedCountsComponent) },
                ]
              },
            ]
          },
        ],
      },

      // ASSET SUMMARY
      {
        path: "asset-summary/:id",
        canActivate: [assetExistsGuard],
        loadComponent: () => fromShared().then(m => m.AssetSummaryPageComponent),
        children: [
          { path: "", redirectTo: "overview", pathMatch: "full" },
          { path: "overview", loadComponent: () => fromShared().then(m => m.AssetOverviewPageComponent), title: TitleResolver },
          { path: "vibration-summary", loadComponent: () => fromShared().then(m => m.AssetVibrationSummaryComponent), title: TitleResolver },
          { path: "map", loadComponent: () => fromShared().then(m => m.AssetMapComponent), title: TitleResolver },
          { path: "alarms", loadComponent: () => fromShared().then(m => m.AssetAlarmsComponent), title: TitleResolver },
          { path: "tags", loadComponent: () => fromShared().then(m => m.AssetTagsComponent), title: TitleResolver },
          { path: "maintenance", loadComponent: () => fromShared().then(m => m.AssetMaintenanceComponent), title: TitleResolver },
          {
            path: "diagnostic-check",
            title: TitleResolver,
            children: [
              { path: "", redirectTo: "config", pathMatch: "full" },
              { path: "config", loadComponent: () => fromShared().then(m => m.AssetDiagnosticCheckConfigComponent) },
            ]
          },
          { path: "more", loadComponent: () => fromShared().then(m => m.AssetSummaryMoreComponent), title: TitleResolver },
          { path: "logbook", loadComponent: () => fromShared().then(m => m.LogbookComponent), title: TitleResolver },
          {
            path: "videos",
            loadComponent: () => fromShared().then(m => m.AssetVideosComponent),
            title: TitleResolver,
            children: [
              {
                path: "camera/:id",
                canActivate: [cameraExistsGuard],
                loadComponent: () => fromShared().then(m => m.CameraViewComponent),
                title: TitleResolver,
                children: [
                  { path: "", redirectTo: "live", pathMatch: "full" },
                  { path: "live", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoLiveComponent) },
                  { path: "historical", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoHistoricalComponent) }
                ]
              },
            ],
          },
          // Playback (already lazy—kept as-is)
          {
            path: "playback",
            title: TitleResolver,
            children: [
              {
                path: "config",
                loadComponent: () => fromShared().then(m => m.PlaybackConfigComponent),
              },
              {
                path: ":view",
                loadComponent: () => import('./playback-view-redirect.component').then(m => m.PlaybackViewRedirectComponent),
              },
              {
                path: "",
                loadComponent: () => fromShared().then(m => m.PlaybackPageComponent),
              },
            ]
          },

          // Historical
          { path: "historical-events",  canActivate: [assetExistsGuard],loadComponent: () => fromShared().then(m => m.HistoricalEventsComponent), title: TitleResolver, },
          { path: "historical-faults",  canActivate: [assetExistsGuard], loadComponent: () => fromShared().then(m => m.HistoricalEventsComponent), title: TitleResolver, },
          { path: "historical-alerts",  canActivate: [assetExistsGuard], loadComponent: () => fromShared().then(m => m.HistoricalEventsComponent), title: TitleResolver, },

          // Tactical report (asset)
          {
            path: "tactical-report",
            loadComponent: () => fromShared().then(m => m.TacticalReportingComponent),
            children: [
              {
                path: "tactical-gstop-five-alarms",
                canActivate: [assetExistsGuard],
                loadComponent: () => fromShared().then(m => m.TacticalGSTopFiveAlarmsComponent),
                title: TitleResolver,
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "topFaults", loadComponent: () => fromShared().then(m => m.TacticalGSTopFiveAlarmsChartComponent) },
                  { path: "categoryTopFaults", loadComponent: () => fromShared().then(m => m.TacticalGSTopFiveAlarmsChartComponent) },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSTopFiveAlarmsSummaryComponent) },
                  { path: "topFaultsByAsset", loadComponent: () => fromShared().then(m => m.TacticalGSTopFiveAlarmsByAssetComponent) },
                  { path: "historical", loadComponent: () => fromShared().then(m => m.TacticalGSTopFiveAlarmsHistoricalComponent) },
                ]
              },
              {
                path: "tactical-gsetop-five-alarms",
                canActivate: [assetExistsGuard],
                loadComponent: () => fromShared().then(m => m.TacticalGSETopFiveAlarmsComponent),
                title: TitleResolver,
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "topFaults", loadComponent: () => fromShared().then(m => m.TacticalGSETopFiveAlarmsChartComponent) },
                  { path: "categoryTopFaults", loadComponent: () => fromShared().then(m => m.TacticalGSETopFiveAlarmsChartComponent) },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSETopFiveAlarmsSummaryComponent) },
                  { path: "topFaultsByAsset", loadComponent: () => fromShared().then(m => m.TacticalGSETopFiveAlarmsByAssetComponent) },
                  { path: "historical", loadComponent: () => fromShared().then(m => m.TacticalGSETopFiveAlarmsHistoricalComponent) },
                ]
              },
            ]
          },
        ],
      },

      // GATE SUMMARY
      {
        path: "gate-summary/:id",
        canActivate: [gateExistsGuard],
        loadComponent: () => fromShared().then(m => m.GateSummaryPageComponent),
        children: [
          { path: "", redirectTo: "overview", pathMatch: "full" },
          { path: "overview", loadComponent: () => fromShared().then(m => m.GateOverviewPageComponent), title: TitleResolver },
          { path: "alarms", loadComponent: () => fromShared().then(m => m.GateAlarmsComponent), title: TitleResolver },
          { path: "tags", loadComponent: () => fromShared().then(m => m.GateTagsComponent), title: TitleResolver },
          { path: "camera-monitoring", loadComponent: () => fromShared().then(m => m.GateCameraMonitoringComponent), title: TitleResolver },
          // Gate Playback (multi-asset, no map)
          {
            path: "playback",
            title: TitleResolver,
            children: [
              { path: "config", loadComponent: () => fromShared().then(m => m.GatePlaybackConfigComponent) },
              { path: ":view", loadComponent: () => import('./playback-view-redirect.component').then(m => m.PlaybackViewRedirectComponent) },
              { path: "", loadComponent: () => fromShared().then(m => m.GatePlaybackPageComponent) },
            ]
          },
          {
            path: "docking-sequence-extraction",
            canActivate: [gateExistsGuard],
            loadComponent: () => fromShared().then(m => m.GateDockingSequenceReportComponent),
            title: 'Docking Sequence Extraction for JetDock Efficiency',
          },

          {
            path: "videos",
            loadComponent: () => fromShared().then(m => m.GateVideosComponent),
            title: TitleResolver,
            children: [
	              {
	                path: "camera/:id",
	                canActivate: [cameraExistsGuard],
	                loadComponent: () => fromShared().then(m => m.CameraViewComponent),
	                title: TitleResolver,
	                children: [
	                  { path: "", redirectTo: "live", pathMatch: "full" },
	                  { path: "live", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoLiveComponent) },
	                  { path: "historical", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoHistoricalComponent) }
	                ]
	              },
	              {
	                path: "multi",
	                loadComponent: () => fromShared().then(m => m.CameraViewComponent),
	                title: TitleResolver,
	                children: [
	                  { path: "", redirectTo: "live", pathMatch: "full" },
	                  { path: "live", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoLiveComponent) },
	                  { path: "live&ids=:ids", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoLiveComponent) },
	                  { path: "historical-configuration", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoHistoricalMultiConfigurationComponent) },
	                  { path: "historical-configuration&ids=:ids", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoHistoricalMultiConfigurationComponent) },
	                  { path: "historical", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoHistoricalMultiComponent) },
	                  { path: "historical&ids=:ids", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoHistoricalMultiComponent) },
	                ]
	              },
	              {
	                path: "system/:id",
	                loadComponent: () => fromShared().then(m => m.CameraViewComponent),
	                title: TitleResolver,
	                children: [
                  { path: "", redirectTo: "live", pathMatch: "full" },
                  { path: "live", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoLiveComponent) },
                  { path: "live/camera/:cameraId", canActivate: [cameraExistsGuard], title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoLiveComponent) },
                  { path: "historical-configuration", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoHistoricalMultiConfigurationComponent) },
                  { path: "historical", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoHistoricalMultiComponent) },
                ]
              },
            ],
          },

          {
            path: "perfect-hookup",
            canActivate: [gateExistsGuard],
            loadComponent: () => fromShared().then(m => m.PerfectHookupComponent),
            title: TitleResolver,
            children: [
              { path: "", redirectTo: "overview", pathMatch: "full" },
              { path: "overview", loadComponent: () => fromShared().then(m => m.PerfectHookupOverviewComponent) },
              { path: "data", loadComponent: () => fromShared().then(m => m.PerfectHookupDataComponent) },
            ],
          },

          {
            path: "perfect-hookup-opportunity",
            canActivate: [gateExistsGuard],
            loadComponent: () => fromShared().then(m => m.PerfectHookupOpportunityComponent),
            title: TitleResolver,
            children: [
              { path: "", redirectTo: "overview", pathMatch: "full" },
              { path: "overview", loadComponent: () => fromShared().then(m => m.PerfectHookupOpportunityOverviewComponent) },
              { path: "data", loadComponent: () => fromShared().then(m => m.PerfectHookupOpportunityDataComponent) },
              { path: "details", loadComponent: () => fromShared().then(m => m.PerfectHookupOpportunityDetailsComponent) },
            ],
          },

          {
            path: "flight-schedule",
            canActivate: [gateExistsGuard],
            loadComponent: () => fromShared().then(m => m.FlightScheduleComponent),
            title: TitleResolver,
            children: [
              { path: "", redirectTo: "schedule", pathMatch: "full" },
              { path: "schedule", loadComponent: () => fromShared().then(m => m.FlightScheduleChartComponent) },
              { path: "data", loadComponent: () => fromShared().then(m => m.FlightScheduleDataComponent) },
              { path: "event/:id", loadComponent: () => fromShared().then(m => m.FlightScheduleEventComponent) },
            ],
          },

          { path: "more", loadComponent: () => fromShared().then(m => m.GateSummaryMoreComponent), title: TitleResolver, },

          {
            path: "tactical-report/:id",
            loadComponent: () => fromShared().then(m => m.TacticalReportingComponent),
            title: TitleResolver,
            children: [
              { path: "chart", loadComponent: () => fromShared().then(m => m.TacticalReportingChartComponent) },
              { path: "data", loadComponent: () => fromShared().then(m => m.TacticalReportingDataComponent) },
            ],
          },
        ],
      },

      // SITE SUMMARY
      {
        path: "site-summary/:id",
        canActivate: [siteExistsGuard],
        loadComponent: () => fromShared().then(m => m.SiteSummaryPageComponent),
        children: [
          { path: "", redirectTo: "overview", pathMatch: "full" },
          { path: "overview", loadComponent: () => fromShared().then(m => m.SiteOverviewComponent), title: TitleResolver },
          { path: "map", loadComponent: () => fromShared().then(m => m.AssetMapComponent), title: TitleResolver },
          { path: "alarms", loadComponent: () => fromShared().then(m => m.SiteAlarmsComponent), title: TitleResolver },
          { path: "camera-monitoring", loadComponent: () => fromShared().then(m => m.SiteCameraMonitoringComponent), title: TitleResolver },
          { path: "fleet-overview", loadComponent: () => fromShared().then(m => m.FleetOverviewComponent), title: TitleResolver },
          { path: "gate-overview", loadComponent: () => fromShared().then(m => m.GateOverviewComponent), title: TitleResolver },

          {
            path: "videos",
            loadComponent: () => fromShared().then(m => m.SiteVideosComponent),
            title: TitleResolver,
            children: [
	              {
	                path: "camera/:id",
	                canActivate: [cameraExistsGuard],
	                loadComponent: () => fromShared().then(m => m.CameraViewComponent),
	                title: TitleResolver,
	                children: [
	                  { path: "", redirectTo: "live", pathMatch: "full" },
	                  { path: "live", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoLiveComponent) },
	                  { path: "historical", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoHistoricalComponent) }
	                ]
	              },
	              {
	                path: "multi",
	                loadComponent: () => fromShared().then(m => m.CameraViewComponent),
	                title: TitleResolver,
	                children: [
	                  { path: "", redirectTo: "live", pathMatch: "full" },
	                  { path: "live", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoLiveComponent) },
	                  { path: "live&ids=:ids", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoLiveComponent) },
	                  { path: "historical-configuration", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoHistoricalMultiConfigurationComponent) },
	                  { path: "historical-configuration&ids=:ids", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoHistoricalMultiConfigurationComponent) },
	                  { path: "historical", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoHistoricalMultiComponent) },
	                  { path: "historical&ids=:ids", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoHistoricalMultiComponent) },
	                ]
	              },
	              {
	                path: "system/:id",
	                loadComponent: () => fromShared().then(m => m.CameraViewComponent),
	                children: [
                  { path: "", redirectTo: "live", pathMatch: "full" },
                  { path: "live", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoLiveComponent) },
                  { path: "live/camera/:cameraId", canActivate: [cameraExistsGuard], title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoLiveComponent) },
                  { path: "historical-configuration", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoHistoricalMultiConfigurationComponent) },
                  { path: "historical", title: TitleResolver, loadComponent: () => fromShared().then(m => m.VideoHistoricalMultiComponent) },
                ]
              },
            ],
          },
          { path: "assets-view", loadComponent: () => fromShared().then(m => m.AssetsViewComponent), title: TitleResolver },

          { path: "tags", loadComponent: () => fromShared().then(m => m.SiteTagsComponent), title: TitleResolver },

          { path: "more",
            // canActivate: [OktaAuthGuard, DataCacheGuard],
            loadComponent: () => fromShared().then(m => m.SiteSummaryMoreComponent), title: TitleResolver },
          { path: "gates-view",
            // canActivate: [OktaAuthGuard, DataCacheGuard],
            loadComponent: () => fromShared().then(m => m.GatesViewComponent), title: TitleResolver },

          {
            path: "perfect-hookup",
            canActivate: [gateSystemsExistsGuard],
            loadComponent: () => fromShared().then(m => m.SitePerfectHookupComponent),
            title: TitleResolver,
            children: [
              { path: "", redirectTo: "overview", pathMatch: "full" },
              { path: "overview", loadComponent: () => fromShared().then(m => m.SitePerfectHookupOverviewComponent) },
            ],
          },

          {
            path: "perfect-hookup-opportunity",
            canActivate: [gateSystemsExistsGuard],
            loadComponent: () => fromShared().then(m => m.PerfectHookupOpportunityComponent),
            title: TitleResolver,
            children: [
              { path: "", redirectTo: "overview", pathMatch: "full" },
              { path: "overview", loadComponent: () => fromShared().then(m => m.PerfectHookupOpportunityOverviewComponent) },
              { path: "data", loadComponent: () => fromShared().then(m => m.PerfectHookupOpportunityDataComponent) },
            ],
          },

          {
            path: "flight-schedule",
            canActivate: [gateSystemsExistsGuard],
            loadComponent: () => fromShared().then(m => m.FlightScheduleComponent),
            title: TitleResolver,
            children: [
              { path: "", redirectTo: "schedule", pathMatch: "full" },
              { path: "schedule", loadComponent: () => fromShared().then(m => m.FlightScheduleChartComponent) },
              { path: "data", loadComponent: () => fromShared().then(m => m.FlightScheduleDataComponent) },
              { path: "event/:id", loadComponent: () => fromShared().then(m => m.FlightScheduleEventComponent) },
            ],
          },

          // SITE TACTICAL REPORTS
          {
            path: "tactical-report",
            loadComponent: () => fromShared().then(m => m.TacticalReportingComponent),
            children: [

              // GS Available Assets
              {
                path: "gs-available-assets",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSAvailableAssetsComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSAvailableAssetsSummaryComponent) },
                  { path: "duration", loadComponent: () => fromShared().then(m => m.TacticalGSAvailableAssetsDurationComponent) },
                  { path: "detail", loadComponent: () => fromShared().then(m => m.TacticalGSAvailableAssetsAggregateComponent) },
                ]
              },

              // GS Alarm Status
              {
                path: "gs-alarm-status",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSAlarmStatusComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSAlarmStatusSummaryComponent) },
                  { path: "duration", loadComponent: () => fromShared().then(m => m.TacticalGSAlarmStatusDurationComponent) },
                  { path: "detail", loadComponent: () => fromShared().then(m => m.TacticalGSAlarmStatusDetailComponent) },
                  { path: "category", loadComponent: () => fromShared().then(m => m.TacticalGSAlarmStatusDetailComponent) },
                ]
              },

              // GSE Fleet Assets In Use
              {
                path: "gse-assets-in-use",
                title: TitleResolver,
                canActivate: [gseAssetsExistsGuard],
                loadComponent: () => fromShared().then(m => m.TacticalGSEAssetsInUseComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSEAssetsInUseSummaryComponent) },
                  { path: "count", loadComponent: () => fromShared().then(m => m.TacticalGSEAssetsInUseCountComponent) },
                  { path: "duration", loadComponent: () => fromShared().then(m => m.TacticalGSEAssetsInUseDurationComponent) },
                  { path: "active-time", loadComponent: () => fromShared().then(m => m.TacticalGSEAssetsInUseActiveTimeComponent) },
                ]
              },

              // GS Assets In Use
              {
                path: "gs-assets-in-use",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSAssetsInUseComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSAssetsInUseSummaryComponent) },
                  { path: "count", loadComponent: () => fromShared().then(m => m.TacticalGSAssetsInUseCountComponent) },
                  { path: "duration", loadComponent: () => fromShared().then(m => m.TacticalGSAssetsInUseDurationComponent) },
                  { path: "total-used", loadComponent: () => fromShared().then(m => m.TacticalGSAssetsInUseTotalUsedComponent) },
                  { path: "type-used", loadComponent: () => fromShared().then(m => m.TacticalGSAssetsInUseTypeUsedComponent) },
                  { path: "type-not-used", loadComponent: () => fromShared().then(m => m.TacticalGSAssetsInUseTypeNotUsedComponent) },
                  { path: "detail", loadComponent: () => fromShared().then(m => m.TacticalGSAssetsInUseDetailComponent) },
                ]
              },

              // Equipment Cycle/Runtime
              {
                path: "equipment",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalEquipmentCycleCountComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalEquipmentCycleCountSummaryComponent) },
                  { path: "cycle-count-report", loadComponent: () => fromShared().then(m => m.TacticalEquipmentCycleCountReportComponent) },
                  { path: "type-cycle-count-report", loadComponent: () => fromShared().then(m => m.TacticalEquipmentTypeCycleCountReportComponent) },
                  { path: "total-cycle-count-report", loadComponent: () => fromShared().then(m => m.TacticalEquipmentTotalCycleCountReportComponent) },
                  { path: "runtime-report", loadComponent: () => fromShared().then(m => m.TacticalEquipmentRuntimeReportComponent) },
                  { path: "type-runtime-report", loadComponent: () => fromShared().then(m => m.TacticalEquipmentTypeRuntimeReportComponent) },
                  { path: "total-runtime-report", loadComponent: () => fromShared().then(m => m.TacticalEquipmentTotalRuntimeReportComponent) },
                ]
              },

              // Levels
              {
                path: "tactical-levels",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalLevelsComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalAssetCurrentLevelsReportComponent) },
                  { path: "current-levels-report", loadComponent: () => fromShared().then(m => m.TacticalCurrentLevelsReportComponent) },
                  { path: "tactical-fuel-levels-report", loadComponent: () => fromShared().then(m => m.TacticalFuelLevelsReportComponent) },
                  { path: "tactical-def-tank-levels-report", loadComponent: () => fromShared().then(m => m.TacticalDefTankLevelsReportComponent) },
                  { path: "tactical-antiice-levels-report", loadComponent: () => fromShared().then(m => m.TacticalAntiiceLevelsReportComponent) },
                  { path: "tactical-battery-levels-report", loadComponent: () => fromShared().then(m => m.TacticalBatteryLevelsReportComponent) },
                  { path: "tactical-deicer-levels-report", loadComponent: () => fromShared().then(m => m.TacticalDeicerLevelsReportComponent) },
                ]
              },

              // PCA Performance
              {
                path: "pca-not-meeting-performance",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.PcaNotMeetingPerformanceComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "current", loadComponent: () => fromShared().then(m => m.PcaNotMeetingPerformanceCurrentComponent) },
                  { path: "chart", loadComponent: () => fromShared().then(m => m.PcaNotMeetingPerformanceChartComponent) },
                  { path: "asset-report", loadComponent: () => fromShared().then(m => m.PcaNotMeetingPerformanceAssetReportComponent) },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.PcaNotMeetingPerformanceSummaryComponent) },
                ]
              },

              // GPU Out Of Compliance
              {
                path: "gpu-out-of-compliance",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                children: [
                  { path: "", loadComponent: () => fromShared().then(m => m.GpuOutOfComplianceSummaryComponent) },
                  { path: "summary", redirectTo: "", pathMatch: "full" },
                ]
              },

              // PBB Out Of Compliance
              {
                path: "pbb-out-of-compliance",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                children: [
                  { path: "", loadComponent: () => fromShared().then(m => m.PbbOutOfComplianceSummaryComponent) },
                  { path: "summary", redirectTo: "", pathMatch: "full" },
                ]
              },

              // PBB Docking
              {
                path: "pbb-docking",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.PbbDockingComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.PbbDockingSummaryComponent) },
                  { path: "current", loadComponent: () => fromShared().then(m => m.PbbDockingCurrentComponent) },
                  { path: "duration-report", loadComponent: () => fromShared().then(m => m.PbbDockingDurationReportComponent) },
                  { path: "count-report", loadComponent: () => fromShared().then(m => m.PbbDockingCountReportComponent) },
                  { path: "total-count-report", loadComponent: () => fromShared().then(m => m.PbbDockingTotalCountReportComponent) },
                  { path: "total-duration-report", loadComponent: () => fromShared().then(m => m.PbbDockingTotalDurationReportComponent) },
                ]
              },

              // GS Alarms (site)
              {
                path: "tactical-gstop-five-alarms",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSTopFiveAlarmsComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "topFaults", loadComponent: () => fromShared().then(m => m.TacticalGSTopFiveAlarmsChartComponent) },
                  { path: "categoryTopFaults", loadComponent: () => fromShared().then(m => m.TacticalGSTopFiveAlarmsChartComponent) },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSTopFiveAlarmsSummaryComponent) },
                  { path: "topFaultsByAsset", loadComponent: () => fromShared().then(m => m.TacticalGSTopFiveAlarmsByAssetComponent) },
                  { path: "historical", loadComponent: () => fromShared().then(m => m.TacticalGSTopFiveAlarmsHistoricalComponent) },
                ]
              },

              // GSE Alarms (site)
              {
                path: "tactical-gsetop-five-alarms",
                canActivate: [gseAssetsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSETopFiveAlarmsComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "topFaults", loadComponent: () => fromShared().then(m => m.TacticalGSETopFiveAlarmsChartComponent) },
                  { path: "categoryTopFaults", loadComponent: () => fromShared().then(m => m.TacticalGSETopFiveAlarmsChartComponent) },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSETopFiveAlarmsSummaryComponent) },
                  { path: "topFaultsByAsset", loadComponent: () => fromShared().then(m => m.TacticalGSETopFiveAlarmsByAssetComponent) },
                  { path: "historical", loadComponent: () => fromShared().then(m => m.TacticalGSETopFiveAlarmsHistoricalComponent) },
                ]
              },

              // Out of service (GS/GSE)
              {
                path: "tactical-gs-out-of-service",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSOutOfServiceComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSOutOfServiceSummaryComponent) },
                  { path: "historical", loadComponent: () => fromShared().then(m => m.TacticalGSOutOfServiceChartComponent) },
                ]
              },
              {
                path: "tactical-gse-out-of-service",
                canActivate: [gseAssetsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSEOutOfServiceComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSEOutOfServiceSummaryComponent) },
                  { path: "historical", loadComponent: () => fromShared().then(m => m.TacticalGSEOutOfServiceChartComponent) },
                ]
              },

              // Fleet usage (GSE)
              {
                path: "tactical-gse-fleet-usage",
                canActivate: [gseAssetsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSEFleetUsageComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSEFleetUsageSummaryComponent) },
                  { path: "usage", loadComponent: () => fromShared().then(m => m.TacticalGSEFleetUsageChartComponent) },
                  { path: "driven", loadComponent: () => fromShared().then(m => m.TacticalGSEFleetUsageDrivenChartComponent) },
                  { path: "idle", loadComponent: () => fromShared().then(m => m.TacticalGSEFleetUsageIdleChartComponent) },
                  { path: "usageDetail", loadComponent: () => fromShared().then(m => m.TacticalGSEFleetUsageDetailChartComponent) },
                  { path: "drivenDetail", loadComponent: () => fromShared().then(m => m.TacticalGSEFleetUsageDrivenDetailChartComponent) },
                  { path: "idleDetail", loadComponent: () => fromShared().then(m => m.TacticalGSEFleetUsageIdleDetailChartComponent) },
                ]
              },

              // Available assets / not used / charging system
              {
                path: "tactical-gse-available-assets",
                canActivate: [gseAssetsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSEAvailableAssetsComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSEAvailableAssetsSummaryComponent) },
                  { path: "minutesOffPerDay", loadComponent: () => fromShared().then(m => m.TacticalGSEAvailableAssetsChartComponent) },
                ]
              },
              {
                path: "tactical-gs-equipment-not-used",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSEquipmentNotUsedComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSEquipmentNotUsedSummaryComponent) },
                  { path: "minutesnotUsedPerDay", loadComponent: () => fromShared().then(m => m.TacticalGSEquipmentNotUsedChartComponent) },
                  { path: "minutesUsedByType", loadComponent: () => fromShared().then(m => m.TacticalGSEquipmentUsedByTypeChartComponent) },
                  { path: "minutesNotUsedByType", loadComponent: () => fromShared().then(m => m.TacticalGSEquipmentNotUsedByTypeChartComponent) },
                  { path: "usedDetail", loadComponent: () => fromShared().then(m => m.TacticalGSEquipmentUsageDetailChartComponent) },
                ]
              },
              {
                path: "tactical-gs-comms-loss",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalGSCommsLossComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalGSCommsLossSummaryComponent) },
                  { path: "detail", loadComponent: () => fromShared().then(m => m.TacticalGSCommsLossDetailChartComponent) },
                  { path: "time", loadComponent: () => fromShared().then(m => m.TacticalGSCommsLossTimeChartComponent) },
                ]
              },
              {
                path: "tactical-intelligent-charging-system",
                canActivate: [gateSystemsExistsGuard],
                title: TitleResolver,
                loadComponent: () => fromShared().then(m => m.TacticalIntelligentChargingSystemComponent),
                children: [
                  { path: "", redirectTo: "summary", pathMatch: "full" },
                  { path: "summary", loadComponent: () => fromShared().then(m => m.TacticalIntelligentChargingSystemSummaryComponent) },
                  { path: "chargedDurationByDay", loadComponent: () => fromShared().then(m => m.TacticalIntelligentChargingSystemChargedByDayDurationChartComponent) },
                  { path: "chargedDuration", loadComponent: () => fromShared().then(m => m.TacticalIntelligentChargingSystemChargedDurationChartComponent) },
                  { path: "counts", loadComponent: () => fromShared().then(m => m.TacticalIntelligentChargingSystemChargedCountsComponent) },
                ]
              },
            ]
          },
        ],
      },
      {
        path: '**',
        loadComponent: () => fromShared().then(m => m.NotFoundRedirectComponent),
      },
        ],
      },
      {
        path: "**",
        canActivate: [legacyOrgRewriteGuard],
        loadComponent: () => fromShared().then(m => m.NotFoundRedirectComponent),
      },
    ],
  },




];
